import { createAppApi } from '../shared';
import type { APIPayload, APIResponse } from './appConfig';
import type { ParsedValues } from './validation';

const ENDPOINT = '/iMetalDeck/';

export function mapInputToPayload(input: ParsedValues): APIPayload {
  return {
    title: input.title,
    span: input.span,
    addedWeight: input.addedWeight,
    supports: input.support,
    sectionName: input.sectionName,
    material: input.material,
    numTroughs: input.numTroughs,
    Pa: input.pressureHistory,
    td: input.timeHistory,
    d0: input.u0,
    v0: input.v0
  };
}

const { analyze, analyzeCancellable } = createAppApi<ParsedValues, APIPayload, APIResponse>(ENDPOINT, mapInputToPayload, { retry: 2, timeout: 15000 });

export { analyze, analyzeCancellable };
